/**
 * Featured templates first, then alphabetical by name (stable tie-break).
 */
export function sortCatalogMaterialTemplates<
  T extends { featuredTemplate?: boolean | null; name: string },
>(items: T[]): T[] {
  return [...items].sort((a, b) => {
    const af = a.featuredTemplate ? 1 : 0
    const bf = b.featuredTemplate ? 1 : 0
    if (bf !== af) {
      return bf - af
    }
    return a.name.localeCompare(b.name, undefined, { sensitivity: 'base' })
  })
}
